import { getRgVersions } from '../../utils/internal/get-versions.js';
import { rgObjectToDto } from '../rg-object/rg-object-to-dto.js';

function rgBriefToDto({ brief, versions = getRgVersions() }) {
    const dto = {
        obj: rgObjectToDto({ rgObj: brief.obj, versions }),
        zoneBriefs: structuredClone(brief.zoneBriefs),
        versions,
        face2FaceSeparation: brief.face2FaceSeparation,
        face2SideSeparation: brief.face2SideSeparation,
        optimisePlots: brief.optimisePlots
    };
    return dto;
}

export { rgBriefToDto };
//# sourceMappingURL=rg-brief-to-dto.js.map
